"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceResourceType = void 0;
exports.WorkspaceResourceType = {
    Voice: "voice",
    VoiceCollection: "voice_collection",
    PronunciationDictionary: "pronunciation_dictionary",
    Dubbing: "dubbing",
    Project: "project",
    ConvaiAgents: "convai_agents",
    ConvaiKnowledgeBaseDocuments: "convai_knowledge_base_documents",
    ConvaiTools: "convai_tools",
    ConvaiSettings: "convai_settings",
    ConvaiSecrets: "convai_secrets",
    MusicLatent: "music_latent",
    ConvaiPhoneNumbers: "convai_phone_numbers",
    ConvaiMcps: "convai_mcps",
    ConvaiBatchCalls: "convai_batch_calls",
};
